import * as React from 'react'
import { ReactElement } from 'react'
import { ListItemDto } from '../../config/partyConfig'
import EntityCombobox, { EntityComboboxProps } from './EntityCombobox'

type Props = Omit<EntityComboboxProps<ListItemDto>, 'getEntityLabel' | 'getEntityValue'>

export default function JudicialInstitutionCombobox(props: Props): ReactElement {
    return (
        <EntityCombobox<ListItemDto>
            getEntityLabel={party => party.displayName}
            getEntityValue={party => party.id}
            placeholderKey={'base.judicialinstitutioncombobox.placeholder'}
            {...props}
        />
    )
}
